import { Component, OnInit, Input, HostBinding } from '@angular/core';
import { StadiumCamera } from 'app/models/stadium-camera';

@Component({
  selector: 'app-stadium-camera',
  templateUrl: './stadium-camera.component.html',
  styleUrls: ['./stadium-camera.component.scss']
})
export class StadiumCameraComponent implements OnInit {
  @Input() stadiumCamera: StadiumCamera;
  @Input() hotSpotDiv: HTMLDivElement;
  @HostBinding('class.active') isActive = false;
  isAdmin: boolean;
  activeSlideIndex: number;

  constructor() { }

  ngOnInit() {
    console.log(this.stadiumCamera)
    this.activeSlideIndex = 0;
  }

  dismiss() {
    this.hotSpotDiv.classList.toggle('clicked');
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/stadium-camera/stadium-camera.component.ts